import { useRef, useState, useEffect } from "react";
import { GridRowsProp } from "@mui/x-data-grid-premium";
import { columns } from "./columns";
import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { NestedSubtableDetailPanel } from "../../../components/datagrid/DetailPanels/NestedSubtable";
import { renderDate } from "../../../formatting/dateFormat";
import api from "../../../apis/dvdlocator";

export function FbaShipmentTablePage() {
  const shipmentsNestedCache = useRef(new Map<string, { rows: GridRowsProp; totalCount: number }>());
  const [lastUpdatedAt, setLastUpdatedAt] = useState<string | null>(null);

  useEffect(() => {
    api
      .get("/tasks", { params: { task_name: "get_fba_shipments", limit: 1 } })
      .then(({ data: json }) => {
        const latest = json.data?.[0];
        if (latest?.ended_at) setLastUpdatedAt(latest.ended_at);
      })
      .catch(console.error);
  }, []);

  return (
    <>
      {lastUpdatedAt && (
        <div
          style={{ padding: "8px 16px", fontSize: "0.875rem", color: "#555" }}
        >
          Last updated at: {renderDate(lastUpdatedAt)}
        </div>
      )}
      <ServerDataGrid
        enableEdit={false}
        enableDelete={false}
        columns={columns}
        apiEndpoint="/datagrid/fba-shipments"
        getRowId={(row) => row.fba_shipments?.shipment_id}
        tableName="shipments"
        getDetailPanelContent={(params, apiRef) => (
          <NestedSubtableDetailPanel
            params={params}
            apiEndpoint="/datagrid/fba-shipments"
            nestedRelationName="fba_shipment_items"
            getRowId={(row) => row.fba_shipment_items?.msku}
            parentApiRef={apiRef}
            cache={shipmentsNestedCache.current}
            columns={[
              {
                headerName: "MSKU",
                field: "fba_shipment_items.msku",
                valueGetter: (value, row) => row.fba_shipment_items?.msku,
                width: 150,
              },
              {
                headerName: "Product Title",
                field: "product.product_title",
                valueGetter: (value, row) => row.product?.product_title,
                width: 280,
              },
              {
                headerName: "Quantity",
                field: "fba_shipment_items.quantity",
                valueGetter: (value, row) => row.fba_shipment_items?.quantity,
                type: "number",
                width: 100,
              },
              {
                headerName: "FNSKU",
                field: "fba_shipment_items.fnsku",
                valueGetter: (value, row) => row.fba_shipment_items?.fnsku,
                width: 140,
              },
              {
                headerName: "ASIN",
                field: "fba_shipment_items.asin",
                valueGetter: (value, row) => row.fba_shipment_items?.asin,
                width: 120,
              },
              {
                headerName: "Label Owner",
                field: "fba_shipment_items.label_owner",
                valueGetter: (value, row) =>
                  row.fba_shipment_items?.label_owner,
                width: 120,
              },
              {
                headerName: "Prep Owner",
                field: "fba_shipment_items.prep_owner",
                valueGetter: (value, row) => row.fba_shipment_items?.prep_owner,
                width: 120,
              },
              {
                headerName: "Current Stock",
                field: "product.stock",
                valueGetter: (value, row) => row.product?.stock,
                type: "number",
                width: 120,
              },
            ]}
          />
        )}
      />
    </>
  );
}
